import { createPathParamCRUD, type NoPathParams } from "@/api/shared/crud";
import { createService } from "@/api/shared/service";
import type { DefaultPaginatedFilters, PaginatedResponse } from "@/api/shared/filters";
import type { TPractice } from "../practice";

export * from "./types";

const SLUG = "practice/me";

export interface IPracticeMeFilters extends DefaultPaginatedFilters {
  company?: string;
  company__type?: "gp" | "orthodontist";
  only_linked_practices?: boolean;
}

export const normalizePracticeMeListResponse = (
  data: TPractice[] | PaginatedResponse<TPractice>
): TPractice[] => (Array.isArray(data) ? data : (data.results ?? []));

export default createService(SLUG, {
  ...createPathParamCRUD<TPractice, NoPathParams, IPracticeMeFilters, never, Partial<TPractice>>(
    SLUG
  ),
});
